$(document).ready(function () {

    var controllerAnim = new ScrollMagic.Controller();

    $('.anim-title').each(function (ind, el) {
        new ScrollMagic.Scene({
            triggerElement: el,
            triggerHook: 0.85,
            offset: 0
        })
            .on("start", function (event) {
                var element = event.target.triggerElement();
                setTimeout(function () {
                    $(element).addClass('animating');
                }, 200);
            })
            //.addIndicators() // add indicators (requires plugin)
            .addTo(controllerAnim);
    });

    $('.link').each(function (ind, el) {
        new ScrollMagic.Scene({
            triggerElement: el,
            triggerHook: 0.85,
            offset: 0
        })
            .on("start", function (event) {
                var element = event.target.triggerElement();
                setTimeout(function () {
                    $(element).addClass('animating');
                }, 200);
            })
            //.addIndicators() // add indicators (requires plugin)
            .addTo(controllerAnim);
    });

    $('.anim-home-hero-link').each(function (ind, el) {
        new ScrollMagic.Scene({
            triggerElement: el,
            triggerHook: 0.85,
            offset: 0
        })
            .on("start", function (event) {
                var element = event.target.triggerElement();
                var delay = $(element).data('delay');
                setTimeout(function () {
                    $(element).addClass('animating');
                }, delay);
            })
            //.addIndicators() // add indicators (requires plugin)
            .addTo(controllerAnim);
    });

    $('.menu-trigger').each(function (ind, el) {
        new ScrollMagic.Scene({
            triggerElement: el,
            triggerHook: 0.85,
            offset: 0
        })
            .on("start", function (event) {
                var element = event.target.triggerElement();
                var delay = $(element).data('delay');
                setTimeout(function () {
                    $(element).addClass('animating');
                }, delay);
            })
            //.addIndicators() // add indicators (requires plugin)
            .addTo(controllerAnim);
    });

    $('.anim-reveal').each(function (ind, el) {
        new ScrollMagic.Scene({
            triggerElement: el,
            triggerHook: 0.85,
            offset: 0
        })
            .on("start", function (event) {
                var element = event.target.triggerElement();
                var delay = $(element).data('delay');
                setTimeout(function () {
                    $(element).addClass('animating');
                }, delay);
            })
            //.addIndicators() // add indicators (requires plugin)
            .addTo(controllerAnim);
    });

});